module.exports = __webpack_public_path__ + "img/2023-30.2fde966a.jpg";